import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";


const Shape = ({ color, size, position, rotation }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const actualSize = isSmall ? size / 1.5 : size;

  return (
    <Box
      sx={{
        position: "absolute",
        width: actualSize,
        height: actualSize,
        borderRadius: "50%",
        background: color,
        opacity: 0.15,
        ...position,
        transform: `rotate(${rotation}deg)`,
        zIndex: -1,
        display: "block",

      }}
    />
  );
};

export default Shape;